// acf_blocks/tenant-category-list – image container hover functionality
(($) => {
  'use strict';

  $(document).ready(() => {
    const $items = $(".acf-blocks-tenant-category-list .menu-item");
    const $hoverImages = $(".acf-blocks-tenant-category-list .hover-img");
    
    // Initially hide all images
    gsap.set($hoverImages, { autoAlpha: 0 });

    $items.each(function() {
      const $menuItem = $(this);
      const $link = $menuItem.find('a[data-index]');
      
      if (!$link.length) return;

      const index = $link.data('index');
      const $correspondingImage = $(`.acf-blocks-tenant-category-list .hover-img[data-index="${index}"]`);

      $menuItem.on('mouseenter', function() {
        // Hide all images first
        gsap.to($hoverImages, { autoAlpha: 0, duration: 0.2 });
        
        // Show the corresponding image
        if ($correspondingImage.length) {
          gsap.to($correspondingImage, { autoAlpha: 1, duration: 0.3 });
        }
      });

      $menuItem.on('mouseleave', function() {
        // Hide the corresponding image
        if ($correspondingImage.length) {
          gsap.to($correspondingImage, { autoAlpha: 0, duration: 0.2 });
        }
      });
    });

    // Hide all images when mouse leaves the entire container
    $('.acf-blocks-tenant-category-list').on('mouseleave', function() {
      gsap.to($hoverImages, { autoAlpha: 0, duration: 0.2 });
    });
  });
})(jQuery);
